// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiPeerToPeer {
    'available'?: string | null;
    'phone'?: string | null;
    'submissionDeadline'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiPeerToPeer>> = [
        {
            "name":     "available",
            "baseName": "available",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "submissionDeadline",
            "baseName": "submissionDeadline",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiPeerToPeer.attributeTypeMap;
    }
}
